<template>
  <div>
      <div class="custom-filter without-border-bottom">
          <div class="custom-filter__inputs align-start">
  <!--            Garantie Types-->
              <label class="custom-filter__inputs--label" style="max-width: 240px;">
              Type de guarantie
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_types.autocar.value"/>
                  <span class="checkboxes__element--text">Autocar</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_types.poids_lourds.value"/>
                  <span class="checkboxes__element--text">Poids Lourds</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.garantie_types.taxi.value"/>
                  <span class="checkboxes__element--text">Taxi/Ambulances/Corbillards</span>
                </label>
              </div>
                <div class="checkboxes-wrap--item">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.garantie_types.vl_vu.value"/>
                    <span class="checkboxes__element--text">VL VU</span>
                  </label>
                </div>
            </label>

              <div class="custom-filter__inputs--label">
                  Date

                  <div class="label currency-datepicker">
                      <div class="label__input-wrap">
                          <datepicker placeholder="De"
                                      format="DD/MM/YYYY"
                                      :monday-first="true"
                                      :full-month-name="true"
                                      wrapper-class="currency-datepicker__wrapper-low-margin mb-3"
                                      input-class="currency-datepicker__input"
                                      calendar-class="currency-datepicker__element"
                                      v-model="filters.start_date"
                                      @focusout.native="focusOutStartDate"
                                      :highlighted="filters.start_date ? '' : highlightedConfig"
                          >
                          </datepicker>
                          <datepicker placeholder="à"
                                      format="DD/MM/YYYY"
                                      :monday-first="true"
                                      :full-month-name="true"
                                      wrapper-class="currency-datepicker__wrapper-low-margin"
                                      input-class="currency-datepicker__input"
                                      calendar-class="currency-datepicker__element"
                                      v-model="filters.end_date"
                                      @focusout.native="focusOutEndDate"
                                      :highlighted="filters.end_date ? '' : highlightedConfig"
                          >
                          </datepicker>
                      </div>
                  </div>
              </div>
  <!--            Periods-->
              <label class="custom-filter__inputs--label">
                Plage de dates
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.today.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">Aujourd’hui</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.yesterday.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">Hier</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.this_week.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">Cette semaine </span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.last_week.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">La semaine dernière</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.this_month.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">Ce mois</span>
                </label>
              </div>
              <div class="checkboxes-wrap--item">
                <label class="checkboxes__element">
                  <input type="checkbox" class="checkboxes__element--input"
                         v-model="filters.periods.last_month.value" :disabled="!isDatesAreEmpty"/>
                  <span class="checkboxes__element--text">Le mois dernier</span>
                </label>
              </div>
                <div class="checkboxes-wrap--item">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.periods.this_year.value" :disabled="!isDatesAreEmpty"/>
                    <span class="checkboxes__element--text">Cette année</span>
                  </label>
                </div>
                <div class="checkboxes-wrap--item">
                  <label class="checkboxes__element">
                    <input type="checkbox" class="checkboxes__element--input"
                           v-model="filters.periods.last_year.value" :disabled="!isDatesAreEmpty"/>
                    <span class="checkboxes__element--text">L’année dernière</span>
                  </label>
                </div>
            </label>
          </div>
      </div>
      <div class="custom-filter__inputs align-start with-border-bottom">
        <label class="custom-filter__inputs--label">
          Montant minimum
          <input class="custom-filter__inputs--field text-type" v-model="filters.min_amount">
        </label>
        <label class="custom-filter__inputs--label">
          Immatriculation
          <input class="custom-filter__inputs--field text-type" v-model="filters.registration">
        </label>
        <label class="custom-filter__inputs--label" v-if="representative_id">
          Partenaire
          <input class="custom-filter__inputs--field text-type" v-model="filters.mechanic_garage">
        </label>
      </div>
      <div class="custom-filter__buttons stats" style="align-items: center; display: flex;">
        <div style="flex-basis: 90%;"><button class="custom-filter__buttons--button" @click="emitFilters">Rechercher</button></div>
        <div><button class="custom-filter custom-icon icon-csv" @click="downloadCSV"></button></div>
        <div><button class="custom-filter custom-icon icon-xlsx" @click="downloadXLSX"></button></div>
      </div>
  </div>
</template>

<script>
    import Datepicker from '@/components/DatepickerCustom/src/components/Datepicker'

    export default {
        name: 'StatisticsAssistanceCustomFilter',
        components: {Datepicker},
        data() {
            return {
              highlightedConfig: {
                    dates: [new Date()],
                }
            }
        },
        props: {
            filters: Object
        },
        computed: {
          isDatesAreEmpty() {
            return !this.filters.start_date && !this.filters.end_date;
          },
          mechanic_id() {
            return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
          },
          representative_id() {
            return this.$store.state.userInfo.representative ? this.$store.state.userInfo.representative.id : '';
          },
        },
        methods: {
            emitFilters() {
                this.$emit('getGarantiesWithFilters');
            },
            focusOutStartDate(event) {
              if (event.target.value == "") {
                this.filters.start_date = null;
                if (!this.filters.end_date) {
                    if (this.filters.periods) {
                      for (let i in this.filters.periods) {
                        let periods = this.filters.periods[i];
                        periods.value = false;
                      }
                    }
                }
              }
            },
            focusOutEndDate(event) {
              if (event.target.value == "") {
                this.filters.end_date = null;
                if (!this.filters.start_date) {
                  if (this.filters.periods) {
                    for (let i in this.filters.periods) {
                      let periods = this.filters.periods[i];
                      periods.value = false;
                    }
                  }
                }
              }
            },
            downloadCSV () {
              this.$emit('garantiesDownloadCSV');
            },
            downloadXLSX () {
              this.$emit('garantiesDownloadXLSX');
            },
        },
        mounted() {

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Statistics/StatisticsAssistanceCustomFilter.vue